<div class="h-100">
    <dx-data-grid id="gridContainer" class="grid theme-dependent" noDataText=""
        [dataSource]="dataSource"
        [allowColumnResizing]="true"
        [focusedRowEnabled]="false"
        [autoNavigateToFocusedRow]="false"
        [showBorders]="true"
        [remoteOperations]="true"
        [columnAutoWidth]="true"
        [wordWrapEnabled]="true"
        [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'compliance-grid-state', savingTimeout: 0 }"
        (onRowDblClick)="onRowDblClick($event)"
        keyExpr="id" width="100%">
        <dxo-load-panel [showPane]="false"></dxo-load-panel>
        <dxo-toolbar>
            <dxi-item location="before">
                <div class="grid-header">Compliance</div>
            </dxi-item>
        </dxo-toolbar>
        <dxi-column [dataField]="gridFieldName('score')" caption="Score" [minWidth]="50" alignment="left"></dxi-column>
        <dxi-column [dataField]="gridFieldName('percentage')" caption="Compliance" [minWidth]="50"
            cellTemplate="compliance" alignment="left"></dxi-column>
        <dxi-column [dataField]="gridFieldName('lastModified')" caption="Last Updated" [minWidth]="100"
            cellTemplate="lastModified" alignment="left"></dxi-column>
        <dxi-column dataField="lastModifiedBy.name" caption="Updated By" cellTemplate="lastModifiedBy" [minWidth]="250"
            [calculateFilterExpression]="lastModifiedByFilter" alignment="left"></dxi-column>
        <dxi-column type="buttons" caption="Actions" alignment="left">
            <dxi-button text="edit" icon="edit" hint="edit" [onClick]="onEdit" [visible]="showEditButton"></dxi-button>
            <dxi-button text="view" icon="eyeopen" hint="view" [onClick]="onView"></dxi-button>
        </dxi-column>

        <div *dxTemplate="let cellInfo of 'lastModifiedBy'">
            <user-avatar-email [email]="getCellData(cellInfo).lastModifiedBy.email"
                [name]="getCellData(cellInfo).lastModifiedBy.name"
                [avatarUrl]="getCellData(cellInfo).lastModifiedBy.avatarUrl"
                [employeeId]="getCellData(cellInfo).lastModifiedBy.id"></user-avatar-email>
        </div>
        <div *dxTemplate="let cellInfo of 'compliance'">
            {{ getCellData(cellInfo).percentage }}%
        </div>
        <div *dxTemplate="let cellInfo of 'lastModified'">
            {{ getCellData(cellInfo).lastModified | date:dateTimeFormat }}
        </div>
    </dx-data-grid>
</div>
<edit-compliance-form [(visible)]="isEditCompliancePopupOpened" [appointmentNumber]="this.appointmentNumber"
    [isReadOnly]="isComplianceReadOnly" (onSave)="onSave()">
</edit-compliance-form>
